module.exports = __webpack_public_path__ + "img/798.72b8a3fe.png";